import {
  Component,
  ElementRef,
  inject,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { AbstractComponent } from '../../abstract.component';
import { RippleDirective } from '../../../directives/ripple.directive';
import { NgClass } from '@angular/common';
import { IconComponent } from '../icon/icon.component';

/* eslint-disable @angular-eslint/component-selector */
@Component({
  selector:
    'a[app-icon-button], button[app-icon-button], span[app-icon-button]',
  templateUrl: './icon-button.component.html',
  styleUrls: ['./icon-button.component.scss'],
  imports: [RippleDirective, NgClass, IconComponent],
})
export class IconButtonComponent
  extends AbstractComponent
  implements OnChanges
{
  private readonly _element: ElementRef = inject(ElementRef);

  @Input({ required: true }) public src?: string;
  @Input({ required: true }) public alt?: string;
  @Input() public border: boolean = false;
  @Input() public large: boolean = false;
  @Input() public badge?: number;
  @Input() public badgeColor?: 'orange' | 'green' = 'green';

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes['alt']) {
      this._element.nativeElement.setAttribute('title', this.alt);
    }
  }
}
